import { useState } from "react"
import Icon from "../../components/Icon"
import PrepayModal from "./PrepayModal"
import { formatMoney } from "../../utils/format"

// Money the customer has pushed to billing companies ahead of their bills, and
// the button that creates more of it. Each row is one company - or one service
// of a company - and what it still holds for this person.
function PrepaidCreditPanel({ prepaymentCredit, onPrepaid }) {
  const [showPrepay, setShowPrepay] = useState(false)

  const issuers = Array.isArray(prepaymentCredit?.issuers) ? prepaymentCredit.issuers : []
  const totalRemaining = Number(prepaymentCredit?.totalRemaining || 0)

  return (
    <section className="rounded-2xl border border-slate-200 bg-white px-4 py-3 shadow-sm">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <Icon name="arrow-up-right-circle" size="0.9rem" className="text-emerald-600" />
            <p className="text-[11px] font-bold uppercase tracking-wide text-slate-400">Prepaid credit</p>
          </div>
          <p className="mt-1 text-xl font-black tracking-tight text-slate-900">
            {formatMoney(totalRemaining)}
          </p>
          {/* Prepaid money is already part of Account credit above. Saying so
              stops the two tiles reading as separate pots of money. */}
          <p className="mt-0.5 text-[11px] text-slate-500">
            Held by companies for your future bills · included in account credit
          </p>
        </div>
        <button
          type="button"
          onClick={() => setShowPrepay(true)}
          className="inline-flex items-center gap-1.5 rounded-xl bg-emerald-600 px-4 py-2 text-sm font-bold text-white transition-colors hover:bg-emerald-700"
        >
          <Icon name="plus-lg" size="0.75rem" />
          Prepay
        </button>
      </div>

      {issuers.length > 0 && (
        <ul className="mt-2.5 divide-y divide-slate-100 border-t border-slate-100">
          {issuers.map((issuer) => (
            <li key={issuer.key || issuer.providerId} className="flex items-center justify-between gap-3 py-2">
              <span className="min-w-0 text-sm font-semibold text-slate-700">
                <span className="truncate">{issuer.providerName || "Billing company"}</span>
                {issuer.accountLabel && (
                  <span className="ml-1.5 rounded-md bg-slate-100 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-slate-500">
                    {issuer.accountLabel}
                  </span>
                )}
              </span>
              <span className="shrink-0 text-sm font-black tabular-nums text-emerald-700">
                {formatMoney(issuer.remainingAmount)}
              </span>
            </li>
          ))}
        </ul>
      )}

      {showPrepay && (
        <PrepayModal
          onDone={onPrepaid}
          onClose={() => setShowPrepay(false)}
        />
      )}
    </section>
  )
}

export default PrepaidCreditPanel
